import { render, staticRenderFns } from "./businessDistrictDetail.vue?vue&type=template&id=44ed5d79&scoped=true"
import script from "./businessDistrictDetail.vue?vue&type=script&lang=js"
export * from "./businessDistrictDetail.vue?vue&type=script&lang=js"
import style0 from "./businessDistrictDetail.vue?vue&type=style&index=0&id=44ed5d79&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed5d79",
  null
  
)

export default component.exports